import { CardElement } from '@stripe/react-stripe-js'
import { StripeCardElementChangeEvent } from '@stripe/stripe-js'

// This was copied from apps/web/app/components/checkout/stripe-card-element.tsx
interface StripeCardElementProps {
  onChange: (e: StripeCardElementChangeEvent) => void
}

export function StripeCardElement({ onChange }: StripeCardElementProps) {
  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <label htmlFor="card-element">Card Details</label>
      <div className="tw-my-2.5 tw-rounded-md tw-border tw-border-solid tw-bg-neutral-200 tw-p-2 tw-px-4 tw-py-2.5 tw-text-black focus:tw-ring-2 focus:tw-ring-cornflower-500">
        <CardElement id="card-element" className="w-full" onChange={onChange} />
      </div>
    </div>
  )
}

// Static property to expose the underlying Stripe component type
// This allows the parent form to get a ref to the CardElement instance via elements.getElement()
StripeCardElement.CardElementComponent = CardElement
